import sensors from '../../sensors';

export default class Detail {
  constructor() {
    // 进入开始时间
    this.start = new Date().getTime();
    // 关闭结束时间
    this.end = this.start;
    this.els = new Set();
    // 是否已经监听
    this.isListener = false;
    // this.mobile = this.isMobile();
    this.value = {};
    // this.isWeChat = this.isWeChatBrowser();
  }

  // isMobile() {
  //   var userAgent = navigator.userAgent;
  //   // 常见的移动端标识
  //   var mobileKeywords = ["Android", "iPhone", "iPad", "iPod", "Windows Phone"];
  
  //   for (var keyword of mobileKeywords) {
  //     if (userAgent.includes(keyword)) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // isWeChatBrowser() {
  //   var ua = navigator.userAgent.toLowerCase();
  //   return ua.match(/micromessenger/i) =='micromessenger';
  // }

  add({ el, value, vnode }) {
    this.value = value;
    if (!this.isListener) {
      this.onListenEvent();
      this.isListener = true;
    }
  }

  // 监听事件
  onListenEvent() {
    // $(window).on("load", this.loadHandler.bind(this));
    // $(window).on("unload", this.unloadHandler.bind(this));
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  }
  handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      this.unloadHandler();
    }else if (document.visibilityState === "visible") {
      this.loadHandler();
    }
  }

  // 进入监听函数
  loadHandler() {
    this.start = new Date().getTime();
    if (sensors.instance) {
      sensors.instance.track("TabPageEnter", this.value);
    }
  }

  // 卸载监听函数
  unloadHandler() {
    this.end = new Date().getTime();
    const view_duration = parseInt((this.end - this.start) / 1000, 10);
    if (sensors.instance) {
      // 测试是否关闭页面会保存本地数据
      // if(process.env.NODE_ENV==="development" || process.env.NODE_ENV==="test"){
      // localStorage.setItem(
      //   new Date().getTime() + "ContentDetail",
      //   JSON.stringify({
      //     ...this.value,
      //     view_duration,
      //   })
      // );
      // }
      sensors.instance.track("TabPageview", {
        ...this.value,
        view_duration,
      });
    }
  }
}
